import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService: React.FC = () => {
  // Enable scrolling for this page
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const rootElement = document.getElementById('root');
    const originalRootOverflow = rootElement?.style.overflow || '';
    
    document.body.style.overflow = 'auto';
    if (rootElement) {
      rootElement.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = originalOverflow;
      if (rootElement) {
        rootElement.style.overflow = originalRootOverflow;
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8 pb-16">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Link>
        
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Kullanım Koşulları</h1>
          
          <div className="text-sm text-gray-600 mb-6">
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </div>
          
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Kabul ve Onay</h2>
              <p>
                Edesis Dijital Tahta uygulamasını ("Uygulama") kullanarak, bu Kullanım Koşullarını kabul etmiş olursunuz. 
                Bu uygulama sadece Edesis sistemini kullanan eğitim kurumları ve bu kurumlara kayıtlı kullanıcılar 
                tarafından kullanılabilir. Hariçten bireysel kullanıcı kaydı yapılmamaktadır. Bu koşulları kabul 
                etmiyorsanız, lütfen Uygulamayı kullanmayın.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Hizmet Tanımı</h2>
              <p>
                Edesis Dijital Tahta, Edesis sistemini kullanan eğitim kurumları için özel olarak tasarlanmış 
                bir dijital tahta uygulamasıdır. Uygulama, bu kurumlara kayıtlı öğrencilerin ve öğretmenlerin 
                soru çözümü yapmasına, not almasına ve çizimleri kaydetmesine olanak tanır. Kullanıcı hesapları 
                yalnızca eğitim kurumları tarafından oluşturulur ve yönetilir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Kullanım Şartları</h2>
              <p className="mb-3">Uygulamayı kullanırken aşağıdaki kurallara uymanız gerekmektedir:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Uygulamayı yalnızca yasal ve eğitim amaçlı kullanmalısınız</li>
                <li>Başkalarının haklarını ihlal eden içerik üretmemelisiniz</li>
                <li>Uygulamanın güvenliğini tehlikeye atacak eylemlerden kaçınmalısınız</li>
                <li>Hesap bilgilerinizi güvenli tutmalı ve başkalarıyla paylaşmamalısınız</li>
                <li>Telif hakkı korumalı içerikleri izinsiz kullanmamalısınız</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Hesap Sorumlulukları</h2>
              <p>
                Kullanıcılar:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Eğitim kurumları tarafından sağlanan hesap bilgilerini güvenli tutmakla yükümlüdür</li>
                <li>Hesap güvenliğinden sorumludur</li>
                <li>Hesaplarında gerçekleşen tüm aktivitelerden sorumludur</li>
                <li>Güvenlik ihlali durumunda derhal eğitim kurumunu ve sistemi bildirmekle yükümlüdür</li>
                <li>Hesap bilgilerini başka kişilerle paylaşmamalıdır</li>
              </ul>
              <p className="mt-3">
                Eğitim Kurumları:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Kullanıcı hesaplarının oluşturulması ve yönetiminden sorumludur</li>
                <li>Kullanıcı bilgilerinin doğruluğunu sağlamakla yükümlüdür</li>
                <li>Mezun olan veya ayrılan kullanıcıların hesaplarını devre dışı bırakmalıdır</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Fikri Mülkiyet Hakları</h2>
              <p className="mb-3">
                Uygulama içeriği ve kullanıcı tarafından oluşturulan içerikler:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Uygulama arayüzü, logosu ve özellikleri Sınavza Bilişim Teknolojileri Limited Şirketi'nin mülkiyetindedir</li>
                <li>Kullanıcılar kendi oluşturdukları içeriklerin haklarını korur</li>
                <li>Eğitim kurumları, öğrenci içeriklerini eğitim amaçlı kullanabilir</li>
                <li>Sınavza Bilişim, hizmet iyileştirmeleri için anonim kullanım verilerini kullanabilir</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Yasaklı Kullanımlar</h2>
              <p className="mb-3">Aşağıdaki eylemler kesinlikle yasaktır:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Yasadışı, zararlı veya rahatsız edici içerik üretmek</li>
                <li>Virüs veya zararlı kod yaymak</li>
                <li>Uygulamanın normal işleyişini bozmak</li>
                <li>Başka kullanıcıların hesaplarına yetkisiz erişim sağlamak</li>
                <li>Uygulamayı ticari amaçlarla izinsiz kullanmak</li>
                <li>Spam veya istenmeyen içerik göndermek</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Hizmet Değişiklikleri</h2>
              <p>
                Sınavza Bilişim, önceden haber vermeksizin:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Hizmetleri değiştirme veya sonlandırma</li>
                <li>Yeni özellikler ekleme veya mevcut özellikleri kaldırma</li>
                <li>Kullanım limitlerini değiştirme</li>
                <li>Fiyatlandırma politikalarını güncelleme hakkını saklı tutar</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Sorumluluk Sınırlaması</h2>
              <p>
                Sınavza Bilişim:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Hizmetin kesintisiz veya hatasız olacağını garanti etmez</li>
                <li>Veri kaybından sorumlu tutulamaz (düzenli yedekleme önerilir)</li>
                <li>Kullanıcı içeriklerinin doğruluğundan sorumlu değildir</li>
                <li>Üçüncü taraf hizmetlerinden kaynaklanan sorunlardan sorumlu değildir</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Tazminat</h2>
              <p>
                Kullanıcılar, Uygulamanın hatalı kullanımından veya bu Koşulların ihlalinden 
                kaynaklanan her türlü zarar, kayıp ve masraftan Sınavza Bilişim'i tazmin etmeyi kabul eder.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">10. Hesap Sonlandırma</h2>
              <p>
                Sınavza Bilişim, aşağıdaki durumlarda hesapları askıya alabilir veya sonlandırabilir:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Kullanım Koşullarının ihlali</li>
                <li>Yasa dışı veya zararlı aktiviteler</li>
                <li>Uzun süreli inaktivite</li>
                <li>Ödeme yükümlülüklerinin yerine getirilmemesi</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">11. Veri Yedekleme</h2>
              <p>
                Kullanıcılar kendi verilerinin yedeğini almaktan sorumludur. Sınavza Bilişim, makul çaba 
                göstermekle birlikte, veri kaybından sorumlu tutulamaz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">12. Gizlilik</h2>
              <p>
                Kişisel verilerinizin nasıl toplandığı ve kullanıldığı hakkında detaylı bilgi için 
                <Link to="/privacy-policy" className="text-blue-600 hover:text-blue-700 ml-1">
                  Gizlilik Politikamızı
                </Link> inceleyiniz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">13. Uygulanacak Hukuk</h2>
              <p>
                Bu Kullanım Koşulları, Türkiye Cumhuriyeti kanunlarına tabi olup, herhangi bir 
                uyuşmazlık durumunda Türkiye mahkemeleri yetkilidir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">14. Değişiklikler</h2>
              <p>
                Bu Kullanım Koşullarını zaman zaman güncelleyebiliriz. Önemli değişiklikler 
                yapıldığında kullanıcılar bilgilendirilecektir. Değişikliklerden sonra Uygulamayı 
                kullanmaya devam etmeniz, yeni koşulları kabul ettiğiniz anlamına gelir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">15. İletişim</h2>
              <p>
                Bu Kullanım Koşulları hakkında sorularınız için:
              </p>
              <ul className="list-none mt-3 space-y-1">
                <li>E-posta: bilgi@sinavza.com</li>
                <li>Şirket: Sınavza Bilişim Teknolojileri Limited Şirketi</li>
                <li>Telefon: 0850 305 8000</li>
              </ul>
            </section>

            <section className="border-t pt-6 mt-8">
              <p className="text-sm text-gray-600">
                Bu Kullanım Koşullarını kabul ederek, yukarıdaki tüm maddeleri okuduğunuzu, 
                anladığınızı ve bunlara uymayı kabul ettiğinizi beyan edersiniz.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;